<div class="container section__simulation h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-300">
      <div class="articleContainer">
        <app-sales-simulator-kredicash-embedded (nextStepEvent)="onNextStep()"></app-sales-simulator-kredicash-embedded>
      </div>
    </div>
  </div>
</div>
